export const SEARCH_PAGE_BREAKPOINTS = {
  XS: 469,
  SM: 620,
  MD: 908,
  LG: 1123,
  XL: 1441,
  XXL: 2060,
};

export const SMALLER_SCREEN_BREAKPOINT = 975;
export const SEARCH_RESULTS_PER_PAGE = 24;

export const DEFAULT_PAGE = "0";

export const CONTENT_SETTINGS_TOGGLE_KEY = "admin_content_settings";
export const VIEW_ALL_STANDARDS = "viewAllStandards";
export const SELECTED_WORKSHEET = "selectedWorksheet";

export enum ContentTypes {
  articleheader = "articleheader",
  audiotrack = "audiotrack",
  externallink = "externallink",
  interactivevideolink = "interactivevideolink",
  textset = "textset",
  standard = "standard",
  video = "video",
}

export enum Grades {
  GRADE_1 = "1st",
  GRADE_2 = "2nd",
  GRADE_3 = "3rd",
  GRADE_4 = "4th",
  GRADE_5 = "5th",
  GRADE_6 = "6th",
  GRADE_7 = "7th",
  GRADE_8 = "8th",
  GRADE_9 = "9th",
  GRADE_10 = "10th",
  GRADE_11 = "11th",
  GRADE_12 = "12th",
  Kindergarten = "K",
}

export interface MaturityRangeValues {
  abbreviation: string;
  ariaLabel: string;
  label: string;
  value: number[];
}

export const MATURITY_RANGE_VALUES: MaturityRangeValues[] = [
  {
    abbreviation: "LE",
    ariaLabel: "Lower elementary school",
    label: "Lower E. School",
    value: [2, 3],
  },
  {
    abbreviation: "UE",
    ariaLabel: "Upper elementary school",
    label: "Upper E. School",
    value: [4, 5],
  },
  {
    abbreviation: "MS",
    ariaLabel: "Middle school",
    label: "Middle School",
    value: [6, 7, 8],
  },
  {
    abbreviation: "HS",
    ariaLabel: "High school",
    label: "High School",
    value: [9, 10, 11, 12],
  },
];

export type LexileLevelsTypes =
  | 60
  | 120
  | 180
  | 240
  | 300
  | 360
  | 420
  | 480
  | 540
  | 600
  | 660
  | 720
  | 780
  | 840
  | 900
  | 960
  | 1020
  | 1080
  | 1140
  | 1200
  | 1260;

export const LEXILE_GRADE_MAP = {
  60: {
    grade: "K",
    lexile: 60,
  },
  120: {
    grade: 1,
    lexile: 120,
  },
  180: {
    grade: 1,
    lexile: 180,
  },
  240: {
    grade: 1,
    lexile: 240,
  },
  300: {
    grade: 2,
    lexile: 300,
  },
  360: {
    grade: 2,
    lexile: 360,
  },
  420: {
    grade: 2,
    lexile: 420,
  },
  480: {
    grade: 2,
    lexile: 480,
  },
  540: {
    grade: 3,
    lexile: 540,
  },
  600: {
    grade: 3,
    lexile: 600,
  },
  660: {
    grade: 4,
    lexile: 660,
  },
  720: {
    grade: 4,
    lexile: 720,
  },
  780: {
    grade: 5,
    lexile: 780,
  },
  840: {
    grade: 5,
    lexile: 840,
  },
  900: {
    grade: 5,
    lexile: 900,
  },
  960: {
    grade: 6,
    lexile: 960,
  },
  1020: {
    grade: 7,
    lexile: 1020,
  },
  1080: {
    grade: 7,
    lexile: 1080,
  },
  1140: {
    grade: 8,
    lexile: 1140,
  },
  1200: {
    grade: "9-10",
    lexile: 1200,
  },
  1260: {
    grade: "11-12",
    lexile: 1260,
  },
};
